import React, { useEffect, useRef, useState } from 'react'

import classes from "./CreateVirtualSource.module.css";


import Modal from '../../../../Modal/Modal';
import Button2 from '../../../Button/Button2';
import { useDispatch } from 'react-redux';
import { getCCTVLicenceCount } from '../../../../../Api Methods/Api';
import { uiActions } from '../../../../../store/ui-slice';

// Which CCTV integration buttons are available, given firmware/site-type support.
const CCTV_OPTIONS = [
    { id: 0, label: "Camect", show: ({ firmwareMajor, firmwareMinor, supportsCamect }) => (firmwareMajor > 1 || (firmwareMajor == 1 && firmwareMinor >= 7)) && supportsCamect == 1 },
    { id: 8, label: "Davantis", show: ({ firmwareMajor }) => firmwareMajor == 3 },
    { id: 12, label: "Ganz AiBox", show: ({ siteType }) => siteType == "S" },
    { id: 9, label: "Hikvision", show: ({ siteType }) => siteType == "S" },
    { id: 14, label: "AJAX", show: ({ siteType }) => siteType == "S" },
    { id: 15, label: "Dahua", show: ({ siteType }) => siteType == "S" },
];

const SelectCCTVIntegration = ({ HandleSelectCamectModalForm, firmwareMajor, firmwareMinor, supportsCamect, siteType, apiData, siteGroupID, isRESUREGroup }) => {

    const ModalDialog = useRef();
    const dispatch = useDispatch();

    const [licenceCount, setLicenceCount] = useState(null);
    // RE:SURE and its subgroups have a hardcoded 100,000 CCTV licences on the backend, so there's
    // nothing to check or gate on for them - skip straight past the loading state.
    const [licenceCountLoading, setLicenceCountLoading] = useState(!isRESUREGroup);

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
        // VirtualSources only mounts this component while showVirtualSource === 7 - without
        // resetting it here, closing via the 'x' (or the dismissable mask) leaves that state at
        // 7, so re-clicking "CCTV Integration" calls setShowVirtualSource(7) again as a no-op
        // and the popup never reopens.
        HandleSelectCamectModalForm(null);
    }

    const handleSelectCamectModalForm = (AutomationID) => {
        HandleCloseModal();
        HandleSelectCamectModalForm(AutomationID);
    }

    useEffect(() => {
        HandleShowModal();

        if (isRESUREGroup) return;

        const fetchLicenceCount = async () => {
            if (!siteGroupID) {
                setLicenceCountLoading(false);
                return;
            }
            const response = await getCCTVLicenceCount(apiData, siteGroupID, dispatch);
            const licenceCount = response.data[0].cctvLicencesRemaining ?? 0;

            setLicenceCount(licenceCount);
            setLicenceCountLoading(false);
        };

        fetchLicenceCount();
    }, []);

    const noLicencesRemaining = !isRESUREGroup && !licenceCountLoading && licenceCount === 0;
    const optionsDisabled = !isRESUREGroup && (licenceCountLoading || noLicencesRemaining);

    const HandlePurchaseMoreLicences = () => {
        HandleCloseModal();
        dispatch(uiActions.openCCTVPurchaseModal(siteGroupID));
    }

    const context = { firmwareMajor, firmwareMinor, supportsCamect, siteType };

    return (
        <Modal ref={ModalDialog} title={"Select CCTV Integration"} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} modalLayoutStyle={{ alignItems: "center" }}>
            <div className={classes.container}>
                {isRESUREGroup ? null : licenceCountLoading ? (
                    <p style={{ margin: "0 0 12px 0", fontSize: "13px", textAlign: "center", color: "#6e6e6e" }}>
                        Checking available CCTV licences...
                    </p>
                ) : noLicencesRemaining ? (
                    <p style={{ margin: "0 0 12px 0", fontSize: "13px", textAlign: "center", color: "#c0392b" }}>
                        There are no remaining CCTV licences —{" "}
                        <a
                            href="#"
                            onClick={(e) => { e.preventDefault(); HandlePurchaseMoreLicences(); }}
                            style={{ color: "#1976d2", textDecoration: "underline", cursor: "pointer" }}
                        >
                            click here
                        </a>{" "}
                        to purchase more.
                    </p>
                ) : (
                    <p style={{ margin: "0 0 12px 0", fontSize: "13px", textAlign: "center", color: "#6e6e6e" }}>
                        {`${licenceCount} CCTV licence${licenceCount === 1 ? "" : "s"} remaining`}
                    </p>
                )}

                {CCTV_OPTIONS.filter(opt => opt.show(context)).map(opt => (
                    <Button2
                        key={opt.id}
                        disabled={optionsDisabled}
                        style={{
                            minWidth: "350px",
                            minHeight: "50px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            opacity: optionsDisabled ? 0.5 : 1,
                            cursor: optionsDisabled ? "not-allowed" : "pointer",
                        }}
                        onClick={() => handleSelectCamectModalForm(opt.id)}
                    >
                        <h4 style={{ margin: "0px" }}>{opt.label}</h4>
                    </Button2>
                ))}
            </div>
        </Modal>
    );
}

export default SelectCCTVIntegration;
